import SuperJSON from "superjson";
import VariableId from "./VariableId";
import { ValueReference } from "../types/ValueReference";

export default class VariableValueReference extends ValueReference<VariableId> {
  toString() {
    return this.id.toString();
  }

  static from(value: string) {
    return new VariableValueReference(VariableId.from(value));
  }
}

SuperJSON.registerClass(VariableValueReference);

// The class name gets minified when building, but this can cause issues in our value references detection (see form version mapping)
// This is a workaround to keep a consistent class name.
Object.defineProperty(VariableValueReference, "name", { value: "VariableValueReference", configurable: true });
